export enum Breakpoint {
    Compact,
    Medium,
    Expanded
}

export function isCompact(breakpoint: Breakpoint): boolean {
    return breakpoint === Breakpoint.Compact;
}

export function isMedium(breakpoint: Breakpoint): boolean {
    return breakpoint === Breakpoint.Medium;
}

export function isExpanded(breakpoint: Breakpoint): boolean {
    return breakpoint === Breakpoint.Expanded;
}

/**
 * Helper function to return the correct value based on the passed in Breakpoint
 *
 * @param breakpoint The breakpoint to determinde the value
 * @param compactValue Value that should be returned when the breakpoint is compact
 * @param mediumValue Value that should be returned when the breakpoint is medium
 * @param expandedValue Value that should be returned when the breakpoint is expanded
 */
export function getBreakpointValue<T>(
    breakpoint: Breakpoint,
    compactValue: T,
    mediumValue: T,
    expandedValue: T
): T {
    if (isCompact(breakpoint)) {
        return compactValue;
    } else if (isMedium(breakpoint)) {
        return mediumValue;
    } else {
        return expandedValue;
    }
}
